import { render, staticRenderFns } from "./private_layout.vue?vue&type=template&id=39a4e95d&scoped=true&"
import script from "./private_layout.vue?vue&type=script&lang=js&"
export * from "./private_layout.vue?vue&type=script&lang=js&"
import style0 from "./private_layout.vue?vue&type=style&index=0&id=39a4e95d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a4e95d",
  null
  
)

export default component.exports